// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"b7b6738e","710":"e5e3e408","983":"423c5980"}[chunkId] + ".chunk.js";
};